module.exports = __webpack_public_path__ + "static/the-c-programming-language-8be2cd28a77f1650354d5bfe153b03da.jpg";